import WithRender from "../../templates/buttons/resetSelectionButton.html";
import { mapActions, mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getIsCimpressProduct"]),
    name: function () {
      return "Reset";
    }
  },
  methods: {
    ...mapActions(["resetSelection"]),
    resetButton: function () {
      this.resetSelection();
    }
  }
});
